import {IErrorResult} from "../../Basic/api";
import {z} from "zod";
import {IOptionWithOwnInput} from "../../Basic/window";

export const InputOption = z.object({
    id: z.number(),
    name: z.string()
})

export type IOption = z.infer<typeof InputOption>

export interface IOptionsResponse {
    data: IOption[]
    error: IErrorResult
}

export interface ISaveEductionRequest {
    education_id: null,
    country: IOptionWithOwnInput,
    city: IOptionWithOwnInput,
    education_institution: IOptionWithOwnInput,
    faculty: IOptionWithOwnInput | null,
    education_level: IOptionWithOwnInput | null,
    start_year: string | null,
    end_year: string | null
}

export const Education = z.object({
    id: z.number(),
    education_institution: z.object(
        {
            id: z.number(),
            name: z.string(),
            education_institution_type: z.object({
                id: z.number(),
                name: z.string(),
            }),
            city: z.object({
                id: z.number(),
                name: z.string(),
                country: z.object({
                    id: z.number(),
                    name: z.string()
                })
            })
        }),
    faculty: z.object({
        id: z.number(),
        name: z.string()
    }).nullable(),
    education_level: z.object({
        id: z.number(),
        name: z.string()
    }).nullable(),
    start_year: z.string().nullable(),
    end_year: z.string().nullable()
})

export type IEducation = z.infer<typeof Education>

export interface IEducationsResponse {
    data: IEducation[]
    error: IErrorResult
}